import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import useForm from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Modal, Form } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

import styles from '../VehicleModal/VehicleModal.module.scss';
import commonStyles from '../../FormComponents/formGroupsCommon.module.scss';

import Validation from '../../Validation/Validation';
import { manufacturerValidations } from '../../../validations/vehicleValidations';
import { storeManufacturer, updateManufacturer } from '../../../redux/modules/vehicles';
import { showNotification } from '../../../helpers/notificationHelpers';
import showErrorNotification from '../../../helpers/errorHandler';

const ManufacturerModal = ({
  openModal,
  setOpenModal,
  modalHeaderText,
  manufacturer,
  setManufacturer,
  loadData,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    register,
    errors,
    clearError,
    handleSubmit,
  } = useForm({
    validationSchema: manufacturerValidations,
    mode: 'onBlur',
  });

  const handleCancel = () => {
    setOpenModal(false);
    setManufacturer({});
  };

  const onSubmit = (data) => {
    const successMessageKey = manufacturer.id
      ? 'vehicleModal.updateManufacturerSuccess'
      : 'vehicleModal.storeManufacturerSuccess';
    const errorMessageKey = 'VEHICLE_ERROR';

    const dispatchAction = manufacturer.id
      ? updateManufacturer({ id: manufacturer.id, ...data })
      : storeManufacturer(data);

    dispatch(dispatchAction)
      .then(() => {
        handleCancel();
        loadData();
        showNotification(successMessageKey, 'success', errorMessageKey);
      })
      .catch((error) => showErrorNotification(error, errorMessageKey));
  };

  return (
    <Modal
      onClose={() => setOpenModal(false)}
      onOpen={() => setOpenModal(true)}
      open={openModal}
      closeOnEscape
      size="tiny"
    >
      <Modal.Header>{modalHeaderText}</Modal.Header>
      <Modal.Content className={styles.formGroupContainer}>
        <Form className={commonStyles.userForm}>
          <Form.Group className={commonStyles.formGroup}>
            <Form.Field width={16}>
              <label className={commonStyles.fieldLabel}>{t('vehicleTbl.name')}</label>
              <Validation name="name" errors={errors} clearError={clearError}>
                <input
                  type="text"
                  name="name"
                  ref={register}
                  autoComplete="off"
                  defaultValue={manufacturer ? manufacturer.name : ''}
                />
              </Validation>
            </Form.Field>
          </Form.Group>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <div className={styles.modalButtonContainer}>
          <button
            type="button"
            className={cn(styles.modalButton, styles.cancel)}
            onClick={handleCancel}
          >
            {t('leaveWarningModal.cancel')}
          </button>
          <button
            type="button"
            className={cn('orange_button', styles.modalButton)}
            onClick={handleSubmit(onSubmit)}
          >
            {t('leaveWarningModal.confirm')}
          </button>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

ManufacturerModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  modalHeaderText: PropTypes.string.isRequired,
  manufacturer: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  setManufacturer: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
};

export default ManufacturerModal;
